import { APP_NAME } from '@tcmark/core/brand';
import { lazy, Suspense } from 'react';
import { Link, Route, Router, Switch } from 'wouter';
import { Splash } from './components/Splash';
import { BASE_PATH } from './lib/url';

// Každá obrazovka je samostatný balíček, telefon tak nenačítá kód Správy.
const PhonePage = lazy(() => import('./phone/PhonePage'));
const ControlPage = lazy(() => import('./control/ControlPage'));
const CalibratePage = lazy(() => import('./calibrate/CalibratePage'));
const SlatePage = lazy(() => import('./slate/SlatePage'));
const AdminApp = lazy(() => import('./admin/AdminApp'));

function HomePage() {
  return (
    <div className="center-page">
      <h1>{APP_NAME}</h1>
      <p className="muted">Otevři odkaz, který jsi dostal od správce session.</p>
      <Link href="/admin" className="btn">
        Správa
      </Link>
    </div>
  );
}

export function App() {
  return (
    <Router base={BASE_PATH}>
      <Suspense fallback={<Splash />}>
        <Switch>
          <Route path="/p/:token">{(p) => <PhonePage token={p.token} />}</Route>
          <Route path="/r/:token">{(p) => <ControlPage token={p.token} />}</Route>
          <Route path="/k/:token/slate">{(p) => <SlatePage token={p.token} />}</Route>
          <Route path="/k/:token">{(p) => <CalibratePage token={p.token} />}</Route>
          <Route path="/admin" nest>
            <AdminApp />
          </Route>
          <Route>
            <HomePage />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}
